import { CreationStatus } from 'redux/middleware/api/creation-service/types';
import {
  creationStatusSelector,
  pollStatusSelector,
  statusSelector,
} from 'redux/modules/wizard-export/selectors';
import { State } from 'redux/types';
import { RequestStatus } from 'types';
import { VideoFlowStep } from './types';

export const createWarnOnStepChangeSelector = (currentStep: VideoFlowStep) => (
  state: State,
) => {
  const creationStatus = creationStatusSelector(state);
  const requestStatus = statusSelector(state);
  const pollStatus = pollStatusSelector(state);

  const isSubmitting =
    currentStep === VideoFlowStep.EXPORT ||
    currentStep === VideoFlowStep.PROGRESS;

  const shouldAllow =
    requestStatus === RequestStatus.FAILURE ||
    pollStatus === RequestStatus.FAILURE ||
    (isSubmitting && creationStatus === CreationStatus.COMPLETED) ||
    (isSubmitting && creationStatus === CreationStatus.FAILED) ||
    (isSubmitting && creationStatus === CreationStatus.EXPORTING_VIDEO);

  return !shouldAllow;
};
